import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from 'react-select';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Rpt_Daily_KPI_Entry = () => {

  const today = new Date().toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [empId, setEmpId] = useState('');
  const [empIds, setEmpIds] = useState([]);
  const [empKPIData, setEmpKPIData] = useState([]);

  useEffect(() => {

    loadMyTeamMembers();

  }, []);

  const loadMyTeamMembers = async () => {

    try {

      const response = await axios.get(`${BASE_URL}/api/ddl_Self_Team`);

      if (response.data && response.data.length > 0) {
        setEmpIds(response.data);
      }

    } catch (err) {

      console.error("Error loading Team Members", err);

    }

  };

  // Fetch report
  const handleRunReport = async () => {

    if (fromDate > toDate) {
      toast.error("From Date cannot be greater than To Date");
      return;
    } else if (empId === '') {
      toast.error("Please select Employee ");
      return;
    }

    try {
      setEmpKPIData([]);
      const res = await axios.get(`${BASE_URL}/api/rpt_Emp_Daily_KPI_Entry`, {
        params: {
          p_Emp_Id: empId,
          p_From_Date: fromDate,
          p_To_Date: toDate
        }
      });

      if (res.data.length > 0) {
        setEmpKPIData(res.data);
      } else {
        setEmpKPIData([]);
        toast.error("No Records Found");
      }
    } catch (err) {
      console.error("Report Error:", err);
      toast.error("Error loading Report.");
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" }); // Jan, Feb, etc.
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const formatDateForFile = (dateStr) => {
    const [year, month, day] = dateStr.split("-"); // safest approach
    return `${day}-${month}-${year}`;
  };

  const handleDownloadPDF = () => {
    if (empKPIData.length === 0) {
      alert("No data to download");
      return;
    }

//    const doc = new jsPDF("landscape");
    const doc = new jsPDF("landscape", "mm", "a3");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const now = new Date();
    const timestamp = now.toLocaleString();

    // ================= HEADER =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.setTextColor(0, 102, 204);
    doc.text("St. Haris High School", pageWidth / 2, 15, { align: "center" });

    /// to print employee name
    const selectedEmp = options_emp.find(
      opt => String(opt.value) === String(empId)
    );

    const empName = selectedEmp.label;

    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(`Employee KPI Entry Report for ${empName}`, pageWidth / 2, 22, { align: "center" });

    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text(`From: ${formatDate(fromDate)}  To: ${formatDate(toDate)}`, pageWidth / 2, 28,{ align: "center" });

    doc.setDrawColor(200);
    doc.line(14, 32, pageWidth - 14, 32);

    // ================= TABLE =================

    const tableColumn = [
      "#",
      "Entry Date",
      "KPI Name",
      "Freq",
      "Emp Remarks",
      "Supervisor Remarks",
      "Supervisor Rating",
      "Supervisor",
      "Sup. Entry Date/Time"
    ];

    const tableRows = empKPIData.map((n, idx) => [
      idx + 1,
      n.entry_date || "",
      n.kpi_name || "",
      n.freq_desc || "",
      n.emp_remarks || "",
      n.sup_rem || "",
      n.sup_rating || "",
      n.sup_name || "",
      n.sup_datetime || ""
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 36,

      styles: {
        fontSize: 7,
        cellPadding: 2,
        overflow: "linebreak" // ✅ wraps text like your React table
      },

      headStyles: {
        fillColor: [0, 102, 204],
        textColor: 255,
        fontStyle: "bold",
        halign: "center"
      },

      columnStyles: {
        0: { halign: "center", cellWidth: 10 },
        1: { cellWidth: 25 },
        2: { cellWidth: 60 }, // KPI Name (bigger + wraps)
        3: { cellWidth: 20 },
        4: { cellWidth: 70 }, // Emp Remarks (wrap)
        5: { cellWidth: 70 }, // Supervisor Remarks (wrap)
        6: { halign: "right", cellWidth: 25 },
        7: { cellWidth: 35 },
        8: { cellWidth: 45 }
      },

      didDrawPage: function () {
        const pageNumber = doc.getNumberOfPages();

        doc.setFontSize(9);
        doc.setTextColor(150);

        doc.setDrawColor(200);
        doc.line(14, pageHeight - 15, pageWidth - 14, pageHeight - 15);

        doc.text("eSchool", 14, pageHeight - 10);

        doc.text(
          `Generated on: ${timestamp}`,
          pageWidth / 2,
          pageHeight - 10,
          { align: "center" }
        );

        doc.text(
          `Page ${pageNumber}`,
          pageWidth - 14,
          pageHeight - 10,
          { align: "right" }
        );
      }
    });

    doc.save(
      `Daily_KPI_Report_${empName}_${formatDateForFile(fromDate)}_to_${formatDateForFile(toDate)}.pdf`
    );
  };

  const handleDownloadExcel = () => {

    if (empKPIData.length === 0) {
      alert("No data to download");
      return;
    }

    const selectedEmp =
      options_emp.find(opt => String(opt.value) === String(empId));

    const empName = selectedEmp.label;

    const reportTitle = [
      [`Daily KPI Entry Report for ${empName}`],
     // [`Employee: ${empName}`],
      [`From: ${formatDate(fromDate)}  To: ${formatDate(toDate)}`],
  //    [""], // empty row for spacing
    ];

    // Prepare table data
    const excelData = empKPIData.map((n, idx) => ({
      "Sr No": idx + 1,
      "Entry Date": n.entry_date || "",
      "KPI Name": n.kpi_name || "",
      "Frequency": n.freq_desc || "",
      "Employee Remarks": n.emp_remarks || "",
      "Supervisor Remarks": n.sup_rem || "",
      "Supervisor Rating": n.sup_rating || "",
      "Supervisor Name": n.sup_name || "",
      "Supervisor Entry Date/Time": n.sup_datetime || ""
    }));

    // Convert data to sheet
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Convert header rows to sheet format
    const headerSheet = XLSX.utils.aoa_to_sheet(reportTitle);

    // Merge header + table
    const finalSheet = XLSX.utils.sheet_add_json(
      headerSheet,
      excelData,
      { origin: "A4" } // 👈 start table from row 5
    );

    // Auto column width
    const colWidths = Object.keys(excelData[0] || {}).map((key) => ({
      wch: Math.max(
        key.length,
        ...excelData.map(row => (row[key] ? row[key].toString().length : 10))
      )
    }));

    finalSheet["!cols"] = colWidths;

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, finalSheet, "KPI Report");

    // File name
    const formatDateForFile = (dateStr) => {
      const [year, month, day] = dateStr.split("-");
      return `${day}-${month}-${year}`;
    };

    const fileName = `Daily_KPI_Report_${empName}_${formatDateForFile(fromDate)}_to_${formatDateForFile(toDate)}.xlsx`;

    // Download
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    saveAs(data, fileName);
  };

  const options_emp = empIds.map(code => ({
    value: code.emp_id,
    label: code.emp_name
  }));

  return (

    <Container fluid className="p-3">

      {/* Filters */}
      <Card className="p-3 mb-3">
        <Row>
          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>From Date</InputGroup.Text>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>To Date</InputGroup.Text>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </InputGroup>
          </Col>

          <Col md={6} className="d-flex justify-content-end">
            <Button variant="primary" className="ms-2"
              disabled={empKPIData.length === 0}
              onClick={handleDownloadPDF}
              >
              Download PDF
            </Button>
            <Button variant="success" className="ms-2"
              onClick={handleDownloadExcel}
              disabled={empKPIData.length === 0}>
              Download Excel
            </Button>
            <Button variant="success" onClick={handleRunReport} className="ms-2">
              Run Report
            </Button>          
          </Col>
        </Row>

        <Row className="mt-3">

          <Col md={6}>

            <Select name="emp_id"
              options={options_emp}
              value={options_emp.find(option => String(option.value) === String(empId)) || null}
              //onChange={selectedOption => setEmpId(selectedOption.value)}
              onChange={(selectedOption) => {
                setEmpId(selectedOption.value);
                setEmpKPIData([]); // 👈 reset data here
              }}
              placeholder=" -- Select Team Member -- "
            />
          </Col>

        </Row>

      </Card>

      {/* Report Table */}
      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-responsive">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table-rcpt hover-table-rcpt">
            <thead className="table-light">
              <tr>
                <th style={{ textAlign: 'center', width: '3%' }}>#</th>
                {/* <th>Notice Type</th> */}
                <th style={{ textAlign: 'left', width: '9%' }} >Entry Date </th>
                <th style={{ textAlign: 'left', width: '20%' }} >KPI Name </th>
                <th style={{ textAlign: 'left', width: '8%' }} >Freq</th>
                <th style={{ textAlign: 'left', width: '25%' }} >Emp Remarks</th>
                <th style={{ textAlign: 'left', width: '20%' }} >Supervisor Remarks</th>
                <th style={{ textAlign: 'right', width: '8%' }} >Supervisor <br/> Rating</th>
                <th style={{ textAlign: 'left', width: '8%' }} >Supervisor</th>
                <th style={{ textAlign: 'left', width: '8%' }} >Sup. Entry <br/> Date/Time</th>
              </tr>
            </thead>

            <tbody>
              {empKPIData.length > 0 ? (
                empKPIData.map((n, idx) => (
                  <tr key={n.irn}>
                    <td style={{ textAlign: 'center' }} >{idx + 1}</td>
                    <td style={{ textAlign: 'left' }}> {n.entry_date} </td>
                    <td style={{ textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word' }} >{n.kpi_name}</td>
                    <td style={{ textAlign: 'left' }}> {n.freq_desc} </td>
                    <td style={{ textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word' }}> {n.emp_remarks} </td>
                    <td style={{ textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word' }}> {n.sup_rem} </td>
                    <td style={{ textAlign: 'right' }}> {n.sup_rating} </td>
                    <td style={{ textAlign: 'left' }}> {n.sup_name} </td>
                    <td style={{ textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word' }}> {n.sup_datetime} </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Entry found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>

    </Container>
  );
};

export default Rpt_Daily_KPI_Entry;
